<template>
    <div class="sports" style="text-align: center;">
      <div class="policy">
        <img src="../../../img/identity/p4f.svg" alt="" style="width: 90%">
        <div class="frame">
          <div class="caption">
            Pocket4Fun er en tjeneste for å nyte tiden din med alt du trenger.
          </div>
          <span class="text text-bold">Abonnement, pris 59 kr/uke.
            <br>Stop? Send SMS med kodeord STOPP til 2015
          </span>
          <q-btn class="btn btn-success" link to="/sports" @click.prevent="accepted">KJØP NÅ</q-btn>
          <div style="padding: 0 0 4% 0;">
            <span class="text" style="font-size: .85em;color: rgba(0,0,0,.5);">
              <div v-html="content.body"></div>
            </span>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
    import contentMixin from '../../helpers/content'
    import {QBtn, Cookies} from "quasar-framework";
    let mixins = [contentMixin]

    export default {
        components: {QBtn},
        mixins,

        metaInfo() {
            return {
                title: 'Terms'
            }
        },
        methods: {
          accepted () {
            Cookies.set('policy_subscribe_accepted', true)
            document.getElementsByClassName('q-layout-header')[0].style.display = "block"
            window.location.href = this.$route.query.slug.replace("*", "/").replace("*", "/")
                .replace("*", "/").replace("*", "/").replace("*", "/")
            //this.$login()
          }
        },
        mounted() {
          document.getElementsByClassName('q-layout-header')[0].style.display = "none"
        }
    }
</script>

<style lang="stylus" scoped>
.frame {
  padding: 2em 0 2em 0;
  border-radius: 1em;
}
.text {
  display: block;
  width: 90%;
  margin: 0 auto 1em auto;
}
.frame .text {
  margin-top: 1em;
}
.frame .caption {
  font-size: 2em;
  font-weight: bold
  padding: 0 1em 1em 1em;
  border-bottom: 1px solid rgba(0,0,0,0.4);
}
.sports {
  width: 100%;
  max-width: 425px;
  margin: 0 auto;
}
.policy
  border: solid 2px red;
  width: 100%
  min-height: 425px
  background-color: #fafafa
  position: relative
  display: flex
  flex-direction column
  align-items: center
  justify-content: center
  border-radius 6px
  .btn
    align-items: center
    justify-content: center
    border: none
    display: block
    cursor pointer
    width: 90%;
    font-size: 2.25em;
    text-transform: uppercase;
    font-weight: 700;
    color: #fff;
    margin: 0 auto .65em auto;
    padding: .65em 0;
    position: relative;
    outline: none;
    border-radius: .1em;
    box-shadow: 0 15px 23px -15px rgb(0 0 0 / 60%);
  .btn-success
    background-color: #02aa4d
  .q-display-1
    text-align center
  .q-body-2
    margin: 10px 0 30px 0
    text-align: center
  .q-body-3
    margin: 30px 0
    text-align: center
  .policy-img
    width 200px
    margin-bottom: 30px

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/policy/index.vue